<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Order history">
 
    <!-- search input 
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Chercher</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Recherche"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>-->
    <!-- table -->
    <vue-good-table
      :columns="$user.main_account==true && $active_account==null ? columnsMain : $user.is_special_user==true ? columnsSpecialUser : columns"
      :rows="orders"
      :pagination-options="{
        enabled: true,
        perPage: Number(pageLength),
        setCurrentPage: 1,
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span
          v-if="props.column.field === 'user.name'"
          class="text-nowrap"
        >
          
          <span class="text-nowrap">{{ props.row.user.name }} {{ props.row.user.surname }}</span>
        </span>
        <span
          v-else-if="props.column.field === 'scan.name'"
          class="text-nowrap"
        >
        
          <template v-if="props.row.order_items.length>0">
            <template v-for="order_item in props.row.order_items">
              <span v-if="order_item.scan && !order_item.size">{{order_item.scan.name}}</span>
              <span v-else-if="order_item.size">{{order_item.size.toUpperCase()}}</span>
              <span v-else>-</span>
              <br />
            </template>
          </template>
        </span>
       
        <span v-else-if="props.column.field === 'stock'">
          <b-badge v-if="props.row.stock>100" variant="light-success">
            {{ props.row.stock }}
          </b-badge>
          <b-badge v-else-if="props.row.stock==0" variant="light-danger">
            {{ props.row.stock }}
          </b-badge>
          <b-badge v-else variant="light-warning">
            {{ props.row.stock }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'items_sort'">
          <div class="order-item-table" v-for="order_item in props.row.order_items">
            <div>{{order_item.glass.name}} x{{order_item.quantity}}</div>
            
          </div>
            
          
        </span>


        <span v-else-if="props.column.field === 'status'">
          <template v-if="$user.is_special_user==true || $isFactory">
            <b-badge v-if="props.row.status=='dispatched'" variant="success">Dispatched</b-badge>
            <b-badge v-else-if="props.row.status=='shipped'" variant="success">Shipped</b-badge>
            <b-badge v-else-if="props.row.status=='scanned'" variant="success">Scans effectués</b-badge>
            <b-badge v-else-if="props.row.status=='delivered'" variant="success">Delivered</b-badge>
            <b-badge v-else-if="props.row.status=='confirmed'" variant="success">Confirmed</b-badge>
            <b-badge v-else-if="props.row.status=='in production'" variant="success">In production</b-badge>
            <b-badge v-else-if="props.row.status=='verified'" variant="success">Verified</b-badge>
            <b-badge v-else-if="props.row.status=='validated'" variant="success">Validated</b-badge>
            <b-badge v-else-if="props.row.status=='ready_to_print'" variant="success">Ready to print</b-badge>
            <b-badge v-else-if="props.row.status=='printing'" variant="success">Printing</b-badge>
            <b-badge v-else-if="props.row.status=='completed'" variant="info">Received</b-badge>
            <b-badge v-else-if="props.row.status=='failed'" variant="danger">Failed</b-badge>
            <b-badge v-else-if="props.row.status=='canceled'" variant="danger">Canceled</b-badge>
            <b-badge v-else-if="props.row.status=='returned'" variant="danger">Returned</b-badge>
          </template>
          <template v-else>
            <b-badge v-if="props.row.status=='dispatched'" variant="success">Dispatched</b-badge>
            <b-badge v-else-if="props.row.status=='scanned'" variant="success">Scans effectués</b-badge>
            <b-badge v-else-if="props.row.status=='delivered'" variant="success">Delivered</b-badge>
            <b-badge v-else-if="props.row.status=='verified'" variant="success">Verified</b-badge>
            <b-badge v-else-if="props.row.status=='validated'" variant="success">Validated</b-badge>
            <b-badge v-else-if="props.row.status=='printing'" variant="success">Printing</b-badge>
            <b-badge v-else-if="props.row.status=='ready_to_print'" variant="success">Ready to print</b-badge>
            <b-badge v-else-if="props.row.status=='completed'" variant="info">Completed</b-badge>
            <b-badge v-else-if="props.row.status=='returned'" variant="danger">Returned</b-badge>
            <b-badge v-else-if="props.row.status=='failed'" variant="danger">Failed</b-badge>
            <b-badge v-else-if="props.row.status=='canceled'" variant="danger">Canceled</b-badge>
            <b-badge v-else variant="danger">error</b-badge>
          </template>
        </span>

        
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'amount'">

          <template v-if="$user.hide_prices!=true">
            <span v-if="props.row.promotion!=null">{{props.row.amount - ((props.row.amount/100)*props.row.promotion.amount).toFixed(2)}}€</span>
            <span v-else>{{props.formattedRow[props.column.field]}}€</span>
          </template>
          <template v-else>On demand</template>
        </span>
     
        <span v-else-if="props.column.field === 'action'">
          <b-button  variant="primary" @click="goToOrderDetail(props.row.id)">
              
                <span>See more</span>
              </b-button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              v-if="totalRows > 0"
              :value="currentPage"
              :total-rows="totalRows"
              :per-page="Number(pageLength)"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="onPageChange"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
     
      </template>
    </vue-good-table>

  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton, VBModal,BOverlay, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// Normalize order dates to a timestamp for reliable numeric sorting in vue-good-table.
function parseOrderDate(v) {
  if (v == null || v === '') return 0
  if (typeof v === 'object' && v.date != null) return parseOrderDate(v.date)
  if (typeof v === 'number') return v < 1e12 ? v * 1000 : v
  const s = String(v).trim()
  // d/M/yyyy, dd/MM/yyyy, also -, . separators (optional time ignored)
  let m = s.match(/^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})/)
  if (m) {
    return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])).getTime()
  }
  // yyyy-MM-dd (ISO date prefix)
  m = s.match(/^(\d{4})[\/.\-](\d{1,2})[\/.\-](\d{1,2})/)
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).getTime()
  }
  const t = Date.parse(s)
  return Number.isNaN(t) ? 0 : t
}

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BOverlay,
    BButton
  },
  data() {
    const pageFromQuery = Number(this.$route.query.page)
    return {
      orders:[],
      pageLength: 10,
      dir: false,
      loading:true,
      totalRows:0,
      currentPage: pageFromQuery > 0 ? pageFromQuery : 1,
      selectedItem:null,
      columnsMain: [
        {
          label: 'Account',
          field: 'user.name',
        },
        {
          label: 'Order',
          field: 'id',
          type: 'number',
        },
        {
          label: 'Date',
          field: 'date_ts',
          type: 'number',
          formatFn: function (value, row) {
            return row && row.date != null ? row.date : null
          },
        },
        {
          label: 'Total price',
          field: 'amount',
          type: 'number',
        },
        {
          label: 'Items',
          field: 'items_sort',
        },
        {
          label: 'Client',
          field: 'client',
          sortable: true,
        },
        {
          label: 'Size',
          field: 'scan.name',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
      ],
      columns: [
        {
          label: 'Order',
          field: 'id',
          type: 'number',
        },
        {
          label: 'Date',
          field: 'date_ts',
          type: 'number',
          formatFn: function (value, row) {
            return row && row.date != null ? row.date : null
          },
        },
        {
          label: 'Total price',
          field: 'amount',
          type: 'number',
        },
        {
          label: 'Items',
          field: 'items_sort',
        },
        {
          label: 'Size',
          field: 'scan.name',
          sortable: false,
        },
      
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
      ],
      columnsSpecialUser: [
        {
          label: 'Order',
          field: 'id',
          type: 'number',
        },
        {
          label: 'Date',
          field: 'date_ts',
          type: 'number',
          formatFn: function (value, row) {
            return row && row.date != null ? row.date : null
          },
        },
        {
          label: 'Total price',
          field: 'amount',
          type: 'number',
        },
        {
          label: 'Items',
          field: 'items_sort',
        },
        {
          label: 'Size',
          field: 'scan.name',
          sortable: false,
        },
        {
          label: 'Client',
          field: 'client',
          sortable: true,
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: '',

    }
  },
  computed: {
    activeAccount() {
      return this.$active_account
    },
  },
  methods: {
    calculateOrderItems(order) {
      let total = 0
      const items = order.order_items || []
      for (let i = 0; i < items.length; i++) {
        total += Number(items[i].quantity) || 0
      }
      return total
    },
    goToOrderDetail(id) {
      this.$router.push({
        name: 'orderDetail',
        params: { id },
        query: { page: this.currentPage },
      })
    },
    onPageChange(page) {
      const nextPage = Number(page)
      if (!nextPage || nextPage === this.currentPage) {
        return
      }
      this.currentPage = nextPage
      this.syncPageQuery()
      this.loadOrdersData()
    },
    syncPageQuery() {
      const currentQueryPage = Number(this.$route.query.page) || 1
      if (currentQueryPage === this.currentPage) {
        return
      }
      const query = { ...this.$route.query }
      if (this.currentPage > 1) {
        query.page = String(this.currentPage)
      } else {
        delete query.page
      }
      this.$router.replace({ query }).catch(() => {})
    },
    async enrichOrders(orders) {
      this.orders = []
      for (let i = 0; i < orders.length; i++) {
        let item = orders[i]
        let order_detail = await APIRequest.detail('orders', orders[i].id)


        if(order_detail.address)
        {
          if(order_detail.address.first_name && order_detail.address.last_name && order_detail.address.first_name != '' && order_detail.address.last_name != '')
          {
            item.client = order_detail.address.first_name + ' ' + order_detail.address.last_name
          }
          else
          {
            item.client = '-'
          }
         
        }
        else
        {
          item.client = '-'
        }

        if (!order_detail.user) {
          if (order_detail.cart != null) {
            if (order_detail.cart.user != null) {
              item.user = {}
              item.user.name = order_detail.cart.user.name
              item.user.surname = order_detail.cart.user.surname
            } else {
              item.user = {}
              item.user.name = ''
              item.user.surname = 'Inconnu'
            }
          } else {
            item.user = {}
            item.user.name = ''
            item.user.surname = 'Inconnu'
          }
        } else {
          item.user = {}
          item.user.name = order_detail.user.name
          item.user.surname = order_detail.user.surname
        }
        if (!order_detail.status) {
          if (order_detail.promotion != null) {
            if (order_detail.promotion.amount == 100) {
              item.status = 'completed'
            }
          } else if (order_detail.cart != null) {
            if (order_detail.cart.promotion != null) {
              if (order_detail.cart.promotion.amount == 100) {
                item.status = 'completed'
              }
            }
          }
        } else {
          item.status = order_detail.status
        }

        item.order_items = order_detail.order_items || []
        if (item.date == null && order_detail.date != null) {
          item.date = order_detail.date
        }
        // Flat fields for vue-good-table sorting
        const firstItem = item.order_items[0]
        item.items_sort = firstItem && firstItem.glass && firstItem.glass.name
          ? String(firstItem.glass.name)
          : ''
        item.date_ts = parseOrderDate(item.date)
        this.orders.push(item)
      }
    },
    async loadOrdersData() {
      this.loading = true
      // Keep the same offset formula as the existing pagination (page * pageLength)
      const offset = this.currentPage > 1 ? this.currentPage * this.pageLength : null
      const keyword = this.searchTerm !== '' ? this.searchTerm : null

      if (this.$user.main_account == true && this.$active_account == null) {
        var request = '?main_user=' + localStorage.id_user_senseye_auth + '&limit=' + this.pageLength + '&order=desc'
        if (keyword) {
          request += '&keyword=' + keyword
        }
        if (offset != null) {
          request += '&offset=' + offset
        }
        var orders = await APIRequest.list_with_request('orders', request)
      } else {
        if (this.$active_account == null) {
          if(this.$isFactory==true)
          {
            console.log('is facto')
            var user_id=this.$user.main_user.id
          }
          else
          {
            var user_id=localStorage.id_user_senseye_auth
          }
        } else {
          var user_id = this.$active_account.id
        }
        var orders = await APIRequest.list('orders', null, null, this.pageLength, offset, null, keyword, null, null, user_id, null, 'desc')
      }

      this.totalRows = orders[1]
      await this.enrichOrders(orders[0])
      this.loading = false
    },
  },
  watch: {
    activeAccount() {
      this.currentPage = 1
      this.syncPageQuery()
      this.loadOrdersData()
    },
    searchTerm() {
      this.pageLength = 10
      this.currentPage = 1
      this.syncPageQuery()
      this.loadOrdersData()
    }
  },
  async mounted() {
    await this.loadOrdersData()
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.order-item-table {
  margin-top:10px;
  &:first-child {
    margin-top:0;
  }
}
</style>
